export default __webpack_public_path__ + "static/media/joystickIcon.38ec22f5.svg";